import React from 'react';

export const RenderFastonSquadra = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => (
  <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
    <g style={{ transformOrigin: '0px 0px' }}>
      
      {/* Forma principale riempita di grigio */}
      <g fill="#BFBFBF" stroke="none" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 697.460084)" style={{ transformOrigin: '0px -697.46px' }}>
        <path fillRule="evenodd" d="M 420 -546.177 L 468 -545.861 C 481.484 -536.413 489.184 -520.712 488.4 -504.265 L 461.946 50.425 C 460.725 76.017 439.621 96.139 414 96.139 L 42 96.139 C 16.379 96.139 -4.725 76.017 -5.946 50.425 L -32.4 -504.265 C -33.184 -520.712 -25.484 -536.413 -12 -545.861 L 36 -544.193 L 420 -546.177 Z M 684.001 -845.859 L -335.974 -845.66 C -374.336 -883.551 -342.155 -851.863 -383.984 -892.889 L -684.001 -892.686 L -684.001 -498.248 L -384.001 -498.248 L -384.001 -498.757 L -336.186 -545.762 L -215.138 -545.859 C -224.345 -464.603 -228.002 -383.046 -228.002 -301.29 L -228.002 1008.142 L 684.001 1008.142 L 684.001 -845.859 Z"/>
      </g>

      {/* Contorni esterni - 8px */}
      <g stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 697.460084)" style={{ transformOrigin: '0px -697.46px' }}>
        <g>
          <path d="M 684 1008.14 L -228 1008.14"/>
          <path d="M 684 1008.14 L 683.997 -845.86" style={{ transformBox: 'fill-box', transformOrigin: '50% 50%' }} transform="matrix(1, 0.000001, -0.000001, 1, 0, 0)"/>
          <path d="M 684.001 -845.86 L -335.97 -845.86"/>
          <path d="M -335.974,-845.66 C -374.336,-883.551 -342.155,-851.863 -383.984,-892.889"/>
          <path d="M -383.984,-892.889 L -684.001,-892.686"/>
          <path d="M -684 -892.69 L -684 -499.09"/>
          <path d="M -228.002,1008.142 V -301.29"/>
          <path d="M -228.002,-301.29 C -228.002,-383.046 -224.345,-464.603 -215.138,-545.859"/>
          <path d="M -215.138,-545.859 L -336.186,-545.762"/>
          <path d="M -336.186,-545.762 L -384.001,-498.757"/>
          <path d="M -384.001,-498.757 V -892.889" style={{ strokeWidth: '4px' }}/>
        </g>
      </g>

      {/* Contorni forma principale - 8px */}
      <g stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 356.962255)">
        <path d="M 420,-546.177 L 468,-545.861"/>
        <path d="M 468,-545.861 C 481.484,-536.413 489.184,-520.712 488.4,-504.265"/>
        <path d="M 488.4,-504.265 L 461.946,50.425"/>
        <path d="M 461.946,50.425 C 460.725,76.017 439.621,96.139 414,96.139"/>
        <path d="M 414,96.139 L 42,96.139"/>
        <path d="M 42,96.139 C 16.379,96.139 -4.725,76.017 -5.946,50.425"/>
        <path d="M -5.946,50.425 L -32.4,-504.265"/>
        <path d="M -32.4,-504.265 C -33.184,-520.712 -25.484,-536.413 -12,-545.861"/>
        <path d="M -12,-545.861 L 36,-544.193"/>
        <path d="M 36,-544.193 L 420,-546.177"/>
      </g>

      {/* Linee interne strutturali - 4px */}
      <g stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 356.962255)">
        <path d="M -384,-498.248 L -384.001,-498.248"/>
        <path d="M 636,96.1386 V -845.861"/>
        <path d="M 588,-845.861 V 96.1386"/>
        <path d="M 366,1008.14 V 96.1386"/>
        <path d="M 90,1008.14 V 96.1386"/>
        <path d="M -180,96.1386 V -301.29"/>
        <path d="M -132,-545.861 V 96.1386"/>
        <path d="M -132,-545.861 c -3.096,0 -5.049,1.122 -6.786,2.456 -1.724,1.346 -3.269,2.868 -4.634,4.567 -2.754,3.374 -4.933,7.313 -6.89,11.469 -3.91,8.316 -6.954,17.482 -9.586,27.052 -5.23,19.174 -8.887,39.892 -11.778,61.361 -2.867,21.492 -4.894,43.809 -6.265,66.77 -1.371,22.961 -2.058,46.593 -2.061,70.896"/>
      </g>

      {/* Linee interne orizzontali - 4px */}
      <g stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 356.962255)">
        <path d="M -227.8 96.139 L 683.803 96.139"/>
        <path d="M 36,-590.027 H 420"/>
        <path d="M 36,-801.695 H 420"/>
        <path d="m -684,-569.861 h 300"/>
        <path d="m -684,-821.861 h 300"/>
        <path d="m -684,-893.036 h 300"/>
        <path d="m -684,-498.687 h 300" style={{ strokeWidth: '8px' }}/>
        <path d="M -215.23 -545.91 L -132.5 -545.91"/>
      </g>

      {/* Linee interne verticali - 4px */}
      <g stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 356.962255)">
        <path d="M 36,-590.027 V -801.52474"/>
        <path d="m 420,-801.695 v 211.71567"/>
        <path d="M -12,-845.06908 V -545.861"/>
        <path d="m 468,-845.861 v 299.56209"/>
        <path d="M -336,-545.85665 V -845.861"/>
      </g>
      {/* Angoli e connessioni - 4px */}
      <g stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="bevel" transform="matrix(0.511695, 0, 0, 0.511695, 0.000165, 356.962255)">
        <path d="m -384,-569.861 48,-66"/>
        <path d="m -384,-821.861 48,66"/>
        <path d="m -384,-893.036 48,47.175"/>
        <path d="m -384,-498.687 48,-47.174"/>
        <path d="m 36,-590.027 -48,44.166"/>
        <path d="m 36,-801.695 -48,-44.166"/>
        <path d="m 420,-801.695 48,-44.166"/>
        <path d="m 420,-590.027 48,44.166"/>
      </g>
      
    </g>
  </g>
);

